import React, { useEffect, useState } from 'react';
import './Recursos.css';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthUser } from '../../context/AuthUserContext';
import { useCart } from '../../context/CartContext';

/* ── APIs ── */
const API_LEADS = 'https://centrocomunicar.com/api-comunicar/endpoints/leads.php';
const API_PAGA  = 'https://centrocomunicar.com/api-comunicar/endpoints/recursos_paga.php';

/* ── Icons ── */
const IconArrow    = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconDownload = () => (<svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M12 3v13M7 11l5 5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M5 21h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCart     = () => (<svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconCartPlus = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 13v4M10 15h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconTag      = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><circle cx="7" cy="7" r="1.5" fill="currentColor"/></svg>);
const IconStar     = ({ filled }) => (<svg viewBox="0 0 24 24" width="13" height="13"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill={filled?'#f59e0b':'none'} stroke="#f59e0b" strokeWidth="2" strokeLinejoin="round"/></svg>);
const IconPdf      = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 2v6h6M9 13h6M9 17h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconKit      = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><rect x="2" y="7" width="20" height="15" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M12 12v6M9 15h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconGame     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><rect x="2" y="6" width="20" height="12" rx="4" stroke="currentColor" strokeWidth="2"/><path d="M7 12h4M9 10v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><circle cx="16" cy="11" r="1" fill="currentColor"/><circle cx="16" cy="13.5" r="1" fill="currentColor" opacity=".5"/></svg>);
const IconGift     = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><polyline points="20 12 20 22 4 22 4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><rect x="2" y="7" width="20" height="5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><line x1="12" y1="22" x2="12" y2="7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconLock     = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconUnlock   = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M7 11V7a5 5 0 019.9-1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconPlay     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/><path d="M10 8l6 4-6 4V8z" fill="currentColor"/></svg>);
const IconCheck    = () => (<svg viewBox="0 0 20 20" fill="none" width="15" height="15"><circle cx="10" cy="10" r="9" fill="rgba(130,216,179,.2)"/><path d="M6 10l3 3 5-5" stroke="#4db88a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconSpinner  = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18" style={{animation:'spin .7s linear infinite'}}><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeOpacity=".25"/><path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconWhatsapp = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconShield   = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconBag      = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);

/* ── Logo ── */
const LogoComunicar = ({ height = 40 }) => (
  <img
    src="/images/logo_centro.png"
    alt="Comunicar"
    style={{ height: height, width: 'auto', display: 'block' }}
  />
);

/* ── Helpers ── */
const colorMap = {
  verde:    { bg:'linear-gradient(135deg,#d4f4e8,#82D8B3)', text:'#0f3525' },
  azul:     { bg:'linear-gradient(135deg,#dbeafe,#60a5fa)', text:'#1e3a5f' },
  amarillo: { bg:'linear-gradient(135deg,#fef9c3,#fbbf24)', text:'#713f12' },
  rosa:     { bg:'linear-gradient(135deg,#fce7f3,#f9a8d4)', text:'#831843' },
  morado:   { bg:'linear-gradient(135deg,#ede9fe,#a78bfa)', text:'#3b0764' },
  gris:     { bg:'linear-gradient(135deg,#f3f8f5,#82D8B3)', text:'#0f3525' },
};
const TIPO_ICONO_GRATIS = { pdf:<IconPdf/>, clase:<IconPlay/>, muestra:<IconKit/>, plantilla:<IconPdf/> };
const TIPO_LABEL_GRATIS = { pdf:'PDF', clase:'Clase', muestra:'Muestra', plantilla:'Plantilla' };
const COLOR_CAT = { Lenguaje:'verde', TEA:'azul', Habla:'amarillo', Aprendizaje:'morado', General:'gris', Familia:'rosa' };

/* ══════════════════════════════════════
   MockupGaleria
══════════════════════════════════════ */
function MockupGaleria({ imagenes }) {
  const [activa, setActiva] = React.useState(0);
  if (!imagenes?.length) return null;
  return (
    <div style={{marginBottom:'1rem'}}>
      <div style={{width:'100%',aspectRatio:'1/1',borderRadius:14,overflow:'hidden',background:'#f3f8f5',marginBottom:'.6rem',position:'relative'}}>
        <img src={imagenes[activa].url} alt={`Vista ${activa+1}`} style={{width:'100%',height:'100%',objectFit:'cover'}}/>
        {imagenes.length > 1 && (
          <>
            <button onClick={()=>setActiva(a=>(a-1+imagenes.length)%imagenes.length)}
              style={{position:'absolute',left:8,top:'50%',transform:'translateY(-50%)',background:'rgba(0,0,0,.45)',border:'none',color:'#fff',borderRadius:'50%',width:32,height:32,cursor:'pointer',fontSize:'1rem',display:'flex',alignItems:'center',justifyContent:'center'}}>‹</button>
            <button onClick={()=>setActiva(a=>(a+1)%imagenes.length)}
              style={{position:'absolute',right:8,top:'50%',transform:'translateY(-50%)',background:'rgba(0,0,0,.45)',border:'none',color:'#fff',borderRadius:'50%',width:32,height:32,cursor:'pointer',fontSize:'1rem',display:'flex',alignItems:'center',justifyContent:'center'}}>›</button>
          </>
        )}
        <div style={{position:'absolute',bottom:8,right:10,background:'rgba(0,0,0,.45)',color:'#fff',fontSize:'.68rem',fontWeight:700,padding:'.15rem .5rem',borderRadius:100}}>
          {activa+1}/{imagenes.length}
        </div>
      </div>
      {imagenes.length > 1 && (
        <div style={{display:'flex',gap:'.4rem',overflowX:'auto',paddingBottom:'.2rem'}}>
          {imagenes.map((img,i) => (
            <button key={img.id||i} onClick={()=>setActiva(i)}
              style={{width:56,height:56,borderRadius:8,overflow:'hidden',flexShrink:0,border:i===activa?'2px solid #4db88a':'2px solid transparent',padding:0,cursor:'pointer',background:'none'}}>
              <img src={img.url} alt={`Mini ${i+1}`} style={{width:'100%',height:'100%',objectFit:'cover'}}/>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

/* ══════════════════════════════════════
   IzipayForm — CONSERVADO INTACTO
══════════════════════════════════════ */
function IzipayForm({ recursoId, monto, email, nombre }) {
  const [loading, setLoading] = React.useState(false);
  const [error,   setError]   = React.useState('');
  const formRef = React.useRef(null);

  const iniciarPago = async () => {
    setLoading(true); setError('');
    try {
      const token = localStorage.getItem('com_token');
      const headers = { 'Content-Type': 'application/json' };
      if (token) headers['Authorization'] = `Bearer ${token}`;
      const codigo = `C${Date.now().toString().slice(-8)}${recursoId}`;
      const r = await fetch('https://centrocomunicar.com/api-comunicar/endpoints/izipay_redirect.php', {
        method: 'POST', headers,
        body: JSON.stringify({ recurso_id:recursoId, monto, email, nombre, pedido_codigo:codigo }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      const form = formRef.current;
      form.action = j.url; form.method = 'POST'; form.innerHTML = '';
      Object.entries(j.params).forEach(([key,val]) => {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = key; input.value = val;
        form.appendChild(input);
      });
      form.submit();
    } catch(err) {
      setError('Error al iniciar el pago: ' + err.message);
      setLoading(false);
    }
  };

  return (
    <div style={{marginTop:'.5rem'}}>
      <div style={{background:'linear-gradient(135deg,#111614 0%,#1a2e26 55%,#0f2a20 100%)',borderRadius:16,padding:'1.1rem 1.3rem',marginBottom:'1rem',position:'relative',overflow:'hidden',boxShadow:'0 8px 28px rgba(17,22,20,.28)',userSelect:'none'}}>
        <div style={{position:'absolute',top:-25,right:-25,width:100,height:100,borderRadius:'50%',background:'rgba(130,216,179,.07)',pointerEvents:'none'}}/>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'1.1rem'}}>
          <div>
            <div style={{fontSize:'.58rem',fontWeight:700,letterSpacing:'.12em',textTransform:'uppercase',color:'rgba(130,216,179,.5)',marginBottom:2}}>Pago seguro</div>
            <div style={{fontSize:'.8rem',fontWeight:700,color:'#82D8B3'}}>🔒 Encriptado SSL</div>
          </div>
          <div style={{display:'flex',gap:'.3rem',alignItems:'center'}}>
            {['VISA','MASTERCARD'].map(b=>(
              <img key={b} src={`https://static.micuentaweb.pe/static/img/payment-method/standard/${b}.png`} alt={b}
                style={{height:20,borderRadius:3,background:'rgba(255,255,255,.88)',padding:'2px 4px',boxShadow:'0 1px 3px rgba(0,0,0,.18)'}}
                onError={e=>e.target.style.display='none'}/>
            ))}
          </div>
        </div>
        <div style={{display:'flex',gap:'.5rem',marginBottom:'.85rem',alignItems:'center'}}>
          {[0,1,2].map(i=>(<span key={i} style={{fontSize:'.9rem',fontWeight:700,color:'rgba(255,255,255,.22)',letterSpacing:'.2em'}}>••••</span>))}
          <span style={{fontSize:'.82rem',fontWeight:600,color:'rgba(255,255,255,.5)',letterSpacing:'.03em',marginLeft:'.15rem'}}>Tu tarjeta</span>
        </div>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-end'}}>
          <div>
            <div style={{fontSize:'.52rem',fontWeight:700,letterSpacing:'.1em',textTransform:'uppercase',color:'rgba(255,255,255,.25)',marginBottom:2}}>Titular</div>
            <div style={{fontSize:'.78rem',fontWeight:600,color:'rgba(255,255,255,.5)'}}>Nombre del titular</div>
          </div>
          <div style={{textAlign:'right'}}>
            <div style={{fontSize:'.52rem',fontWeight:700,letterSpacing:'.1em',textTransform:'uppercase',color:'rgba(255,255,255,.25)',marginBottom:2}}>Vence</div>
            <div style={{fontSize:'.78rem',fontWeight:600,color:'rgba(255,255,255,.5)'}}>MM/AA</div>
          </div>
        </div>
      </div>
      <div style={{display:'flex',gap:'.4rem',marginBottom:'1rem',flexWrap:'wrap'}}>
        {[{icon:'🔒',label:'SSL seguro'},{icon:'✅',label:'Verificado Izipay'},{icon:'🛡️',label:'Sin guardar datos'}].map(({icon,label})=>(
          <div key={label} style={{display:'flex',alignItems:'center',gap:'.3rem',background:'#edfaf4',borderRadius:100,padding:'.3rem .75rem',fontSize:'.68rem',fontWeight:700,color:'#4db88a',border:'1px solid rgba(130,216,179,.3)'}}>
            <span style={{fontSize:'.75rem'}}>{icon}</span><span>{label}</span>
          </div>
        ))}
      </div>
      {error && <div style={{background:'#fff5f5',border:'1px solid #fecaca',borderRadius:8,padding:'.6rem 1rem',fontSize:'.78rem',color:'#c53030',marginBottom:'.8rem'}}>{error}</div>}
      <button onClick={iniciarPago} disabled={loading} style={{background:loading?'#5a6a63':'#111614',color:'#82D8B3',fontFamily:"'DM Sans',sans-serif",fontWeight:700,fontSize:'.9rem',letterSpacing:'.05em',textTransform:'uppercase',border:'none',borderRadius:100,padding:'.9rem 2rem',width:'100%',cursor:loading?'not-allowed':'pointer',boxShadow:'0 4px 16px rgba(17,22,20,.2)',transition:'all .22s',display:'flex',alignItems:'center',justifyContent:'center',gap:'.5rem'}}>
        {loading?(<><svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{animation:'spin .7s linear infinite'}}><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeOpacity=".25"/><path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>Redirigiendo…</>):(<>💳 Ir a pagar con tarjeta</>)}
      </button>
      <p style={{textAlign:'center',marginTop:'.7rem',fontSize:'.68rem',color:'#5a6a63'}}>Serás redirigido al portal seguro de Izipay para completar el pago</p>
      <div style={{textAlign:'center',marginTop:'.5rem',paddingTop:'.6rem',borderTop:'1px solid #eef2ef',fontSize:'.65rem',color:'#5a6a63'}}>🛡️ Procesado por <strong style={{color:'#4db88a'}}>Izipay</strong> · No guardamos datos de tu tarjeta</div>
      <form ref={formRef} style={{display:'none'}}/>
    </div>
  );
}

/* ══════════════════════════════════════
   ToastCarrito
══════════════════════════════════════ */
function ToastCarrito({ item, onVer, onCerrar }) {
  useEffect(() => {
    const t = setTimeout(onCerrar, 3500);
    return () => clearTimeout(t);
  }, [onCerrar]);
  return (
    <div style={{position:'fixed',bottom:'2rem',right:'2rem',zIndex:9999,background:'#111614',color:'#fff',borderRadius:16,padding:'1rem 1.2rem',boxShadow:'0 8px 32px rgba(0,0,0,.35)',display:'flex',alignItems:'center',gap:'1rem',maxWidth:320,width:'90%',animation:'slideInRight .3s ease'}}>
      <div style={{width:38,height:38,borderRadius:10,background:'#82D8B3',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><IconCheck/></div>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:'.72rem',color:'rgba(255,255,255,.5)',marginBottom:'.1rem'}}>Agregado al carrito</div>
        <div style={{fontSize:'.86rem',fontWeight:700,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{item?.titulo}</div>
      </div>
      <button onClick={onVer} style={{background:'#82D8B3',color:'#111614',border:'none',borderRadius:100,padding:'.4rem .85rem',fontFamily:'inherit',fontWeight:700,fontSize:'.75rem',cursor:'pointer',whiteSpace:'nowrap',flexShrink:0}}>
        Ver carrito
      </button>
    </div>
  );
}

/* ══════════════════════════════════════
   RecursoCard — estilo brandbook
══════════════════════════════════════ */
const RecursoCard = ({ r, onComprar, iconMap }) => {
  const col = colorMap[r.color] || colorMap.verde;
  const Icon = iconMap[r.tipo] || IconPdf;
  const { agregarItem, estaEnCarrito } = useCart();
  const { estaLogueado } = useAuthUser();
  const navigate = useNavigate();
  const enCarrito = estaEnCarrito(r.id);

  const dtoPct = r.precio_antes
    ? Math.round((1 - parseFloat(r.precio) / parseFloat(r.precio_antes)) * 100)
    : 30;

  return (
    <article className="mat-card reveal" style={{cursor:'pointer'}} onClick={() => navigate(`/recursos/${r.id}`)}>

      {/* THUMB — 4:3 con badge rojo descuento */}
      <div className="mat-card__thumb" style={{
        background: r.imagen_url ? 'none' : col.bg,
        backgroundImage: r.imagen_url ? `url(${r.imagen_url})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        aspectRatio: '4 / 3',
        minHeight: 'unset',
      }}>
        {!r.imagen_url && <div className="mat-card__thumb-icon" style={{color:col.text}}><Icon/></div>}

        {/* Badge rojo descuento — esquina superior izquierda */}
         {/* <div className="mat-card__dto-badge">
          {r.precio_antes ? `${dtoPct}% Dto.` : '30% Dto.'}
        </div>*/}

        {r.badge && <span className="mat-card__badge mat-card__badge--dest">{r.badge}</span>}
      </div>

      {/* BODY */}
      <div className="mat-card__body">
        <span className="mat-card__cat">{(r.categoria||'Materiales').toUpperCase()}</span>
        <h3 className="mat-card__titulo">{r.titulo}</h3>
        {r.descripcion && (
          <p className="mat-card__desc">{r.descripcion.length>85?r.descripcion.slice(0,85)+'…':r.descripcion}</p>
        )}
        <div className="mat-card__meta">
          {r.formato && <span><IconPdf/>{r.formato}</span>}
          {r.paginas && <span><IconTag/>{r.paginas} págs.</span>}
        </div>
        {r.rating > 0 && (
          <div className="mat-card__rating">
            {[1,2,3,4,5].map(n=><IconStar key={n} filled={n<=Math.round(r.rating)}/>)}
            <span>{r.rating}</span>
            {r.ventas > 0 && <span className="mat-card__ventas">· {r.ventas} ventas</span>}
          </div>
        )}
      </div>

      {/* FOOTER */}
      <div className="mat-card__footer">
        <div>
          <span className="mat-card__precio">S/. {parseFloat(r.precio||0).toFixed(0)}</span>
          {r.precio_antes && <s className="mat-card__precio-antes">S/. {parseFloat(r.precio_antes).toFixed(0)}</s>}
        </div>
        <div style={{display:'flex',gap:'.35rem',alignItems:'center',flexWrap:'nowrap'}}>
          {enCarrito ? (
            <button className="mat-card__btn" style={{background:'#4db88a',color:'#fff'}}
              onClick={(e) => { e.stopPropagation(); navigate('/carrito'); }}>
              <IconBag/> Ver carrito
            </button>
          ) : (
            <button className="mat-card__btn"
              onClick={(e) => {
                e.stopPropagation();
                if (!estaLogueado) { navigate('/login?redirect=/recursos'); return; }
                agregarItem({
                  id: r.id, titulo: r.titulo,
                  precio: parseFloat(r.precio || 0),
                  tipo: r.tipo, color: r.color,
                  imagen: r.imagen_url || null,
                  descripcion_larga: r.descripcion_larga || null,
                  imagenes: r.imagenes || [],
                  digital: true,
                });
              }}>
              <IconCartPlus/> Agregar
            </button>
          )}
          <button
            onClick={(e) => { e.stopPropagation(); navigate(`/recursos/${r.id}`); }}
            className="mat-card__btn-detalle">
            Ver detalle
          </button>
        </div>
      </div>
    </article>
  );
};

/* ══════════════════════════════════════
   MatBloque — con prop sub
══════════════════════════════════════ */
const MatBloque = ({ id, label, titulo, tituloEm, sub, bg, icon, items, loading, onComprar, iconMap, estaLogueado, onLoginRequerido }) => (
  <section className={`mat-bloque ${bg||''} reveal`} id={id}>
    <div className="mat-bloque__inner">
      
    <div className="mat-bloque__head">
          <div className="mat-bloque__head-left" style={{flexDirection:'column',alignItems:'flex-start'}}>
            <p className="section-label" style={{display:'flex',alignItems:'center',gap:'.4rem',marginBottom:'.3rem'}}>{icon}{label}</p>
            <h2 className="mat-bloque__titulo">{titulo}{tituloEm && <> <em>{tituloEm}</em></>}</h2>
            {sub && <p className="mat-bloque__sub">{sub}</p>}
          </div>
       
      </div>
      {loading && <div className="mat-loading"><IconSpinner/><span>Cargando…</span></div>}
      {!loading && items.length === 0 && (
        <div className="mat-empty"><p>Próximamente más materiales en esta categoría.</p></div>
      )}
      {!loading && items.length > 0 && (
        <div className="mat-grid">
          {items.map(r => <RecursoCard key={r.id} r={r} onComprar={onComprar} iconMap={iconMap} estaLogueado={estaLogueado} onLoginRequerido={onLoginRequerido}/>)}
        </div>
      )}
    </div>
  </section>
);

/* ════════════════════════════════════════
   COMPONENTE PRINCIPAL
════════════════════════════════════════ */
export default function Recursos() {
  const { estaLogueado, usuario } = useAuthUser();
  const { totalItems, ultimoAgregado, limpiarUltimoAgregado } = useCart();
  const navigate = useNavigate();

  const [gratisData,    setGratisData]    = useState([]);
  const [pagaData,      setPagaData]      = useState([]);
  const [loadingGratis, setLoadingGratis] = useState(true);
  const [loadingPaga,   setLoadingPaga]   = useState(true);

  const [modalRecurso, setModalRecurso] = useState(null);
  const [formGratis,   setFormGratis]   = useState({ nombre:'', email:'' });
  const [enviando,     setEnviando]     = useState(false);
  const [descargaOk,   setDescargaOk]   = useState(false);
  const [descargaUrl,  setDescargaUrl]  = useState(null);
  const [formError,    setFormError]    = useState('');

  const [modalCompra,      setModalCompra]      = useState(null);
  const [compraStep,       setCompraStep]        = useState('info');
  const [formCompra,       setFormCompra]        = useState({ nombre:'', email:'', telefono:'' });
  const [comprando,        setComprando]         = useState(false);
  const [comprError,       setComprError]        = useState('');
  const [pedidoData,       setPedidoData]        = useState(null);
  const [puntosUsuario,    setPuntosUsuario]      = useState(null);
  const [usarPuntos,       setUsarPuntos]         = useState(false);
  const [puntosAplicar,    setPuntosAplicar]      = useState(0);
  const [metodoPagoModal,  setMetodoPagoModal]    = useState(null);
  const [iziForm,          setIziForm]            = useState(null);
  const [iziLoading,       setIziLoading]         = useState(false);
  const [iziError,         setIziError]           = useState('');

  useEffect(() => {
    fetch(`${API_LEADS}?action=recursos`)
      .then(r=>r.json())
      .then(j=>{ if(j.success) setGratisData(j.data||[]); })
      .catch(()=>{})
      .finally(()=>setLoadingGratis(false));
  }, []);

  useEffect(() => {
    fetch(`${API_PAGA}?action=list`)
      .then(r=>r.json())
      .then(j=>{ if(j.success && j.data?.length > 0) setPagaData(j.data); })
      .catch(()=>{})
      .finally(()=>setLoadingPaga(false));
  }, []);

  useEffect(() => {
    const io = new IntersectionObserver(
      entries=>entries.forEach(e=>{ if(e.isIntersecting){e.target.classList.add('visible');io.unobserve(e.target);} }),
      { threshold:0.06 }
    );
    document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
    return ()=>io.disconnect();
  }, [loadingGratis, loadingPaga]);

  const imprimibles = pagaData.filter(r => r.tipo === 'recurso' && r.activo);
  const kits        = pagaData.filter(r => r.tipo === 'kit'     && r.activo);
  const juegos      = pagaData.filter(r => r.tipo === 'juego'   && r.activo);
  const iconMap     = { recurso: IconPdf, juego: IconGame, kit: IconKit };

  const abrirModal = (recurso) => {
    setModalRecurso(recurso);
    setFormGratis(estaLogueado ? { nombre:usuario.nombre, email:usuario.email } : { nombre:'', email:'' });
    setDescargaOk(false); setDescargaUrl(null); setFormError('');
  };

  const handleDescargar = async e => {
    e.preventDefault(); setFormError('');
    if (!formGratis.nombre.trim()) { setFormError('Ingresa tu nombre'); return; }
    if (!formGratis.email.includes('@')) { setFormError('Email no válido'); return; }
    setEnviando(true);
    try {
      const res = await fetch(`${API_LEADS}?action=lead`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ nombre:formGratis.nombre, email:formGratis.email.toLowerCase(), recurso_slug:modalRecurso.slug, fuente:'pagina_recursos' }),
      });
      const json = await res.json();
      if (!json.success) throw new Error(json.message);
      setDescargaOk(true); setDescargaUrl(json.data?.recurso?.archivo_url);
    } catch(err) { setFormError(err.message||'Error al procesar. Intenta de nuevo.'); }
    finally { setEnviando(false); }
  };

  const abrirCompra = (r) => {
    setModalCompra(r); setCompraStep('info'); setComprError('');
    setPedidoData(null); setUsarPuntos(false); setPuntosAplicar(0);
    setMetodoPagoModal(null); setIziForm(null); setIziError('');
    if (estaLogueado) {
      const token = localStorage.getItem('com_token');
      fetch(`${API_PAGA}?action=mis_puntos`, { headers:{'Authorization':`Bearer ${token}`} })
        .then(res=>res.json()).then(j=>{ if(j.success) setPuntosUsuario(j.data); }).catch(()=>{});
    }
    setFormCompra(estaLogueado ? { nombre:usuario.nombre, email:usuario.email, telefono:usuario.whatsapp||'' } : { nombre:'', email:'', telefono:'' });
  };

  const puntosDisponibles = puntosUsuario?.puntos_disponibles || 0;
  const puntosMaxUsar     = Math.min(puntosDisponibles, Math.floor((parseFloat(modalCompra?.precio||0)*0.30)*100));
  const descuentoPuntos   = usarPuntos ? parseFloat((puntosAplicar/100).toFixed(2)) : 0;
  const montoFinal        = Math.max(0, parseFloat((parseFloat(modalCompra?.precio||0)-descuentoPuntos).toFixed(2)));

  const handleComprar = async e => {
    e.preventDefault(); setComprError('');
    if (!formCompra.nombre.trim()) { setComprError('Ingresa tu nombre'); return; }
    if (!formCompra.email.includes('@')) { setComprError('Email no válido'); return; }
    setComprando(true);
    try {
      const token = localStorage.getItem('com_token');
      const headers = {'Content-Type':'application/json'};
      if (token) headers['Authorization'] = `Bearer ${token}`;
      const res = await fetch(`${API_PAGA}?action=crear_pedido`, {
        method:'POST', headers,
        body:JSON.stringify({ recurso_id:modalCompra.id, nombre:formCompra.nombre, email:formCompra.email.toLowerCase(), telefono:formCompra.telefono, puntos_usados:usarPuntos?puntosAplicar:0, descuento_puntos:descuentoPuntos, monto_final:montoFinal }),
      });
      const json = await res.json();
      if (!json.success) throw new Error(json.message);
      setPedidoData(json.data); setCompraStep('ok');
    } catch(err) { setComprError(err.message||'Error al procesar. Intenta de nuevo.'); }
    finally { setComprando(false); }
  };

  const abrirWhatsApp = () => { if (pedidoData?.wa_url) window.open(pedidoData.wa_url,'_blank'); };

  return (
    <div className="rec-page">

      {ultimoAgregado && (
        <ToastCarrito
          item={ultimoAgregado}
          onVer={() => { navigate('/carrito'); limpiarUltimoAgregado(); }}
          onCerrar={limpiarUltimoAgregado}
        />
      )}

      {/* ══ NAV ══ */}
      <nav className="nav">
        <Link to="/" className="nav__logo"><LogoComunicar height={44}/></Link>
        <div className="nav__links">
          <Link to="/">Inicio</Link>
          <Link to="/formaciones">Cursos</Link>
          <Link to="/recursos" style={{color:'var(--verde-dk)',fontWeight:700}}>Materiales</Link>
          <Link to="/comunidad">Comunidad</Link>
          <Link to="/articulos">Blog</Link>

          <a href="https://centrocomunicar.com/virtual/login/index.php"
            target="_blank" rel="noopener noreferrer"
            className="nav__aula-btn">
            <span className="aula-icon">📖</span>
            Aula Virtual
          </a>


        </div>
        <div className="nav__actions">
          <Link to="/carrito"
            style={{position:'relative',display:'flex',alignItems:'center',padding:'.4rem .7rem',borderRadius:100,border:'1.5px solid rgba(130,216,179,.3)',color:'var(--gris,#5a6a63)',transition:'all .2s'}}
            title="Ver carrito">
            <IconCart/>
            {totalItems > 0 && (
              <span style={{position:'absolute',top:-6,right:-6,background:'#82D8B3',color:'#111614',borderRadius:'50%',width:18,height:18,fontSize:'.62rem',fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center',lineHeight:1}}>
                {totalItems > 9 ? '9+' : totalItems}
              </span>
            )}
          </Link>
          {estaLogueado
            ? <Link to="/mi-cuenta" className="nav__mi-cuenta">● {usuario.nombre}</Link>
            : <Link to="/login" className="nav__login">Iniciar sesión</Link>
          }
        </div>
      </nav>

      {/* ══ MATERIALES GRATUITOS ══ */}
      <section className="rec-gratis mat-hero-section" id="gratuitos">
        <div className="rec-gratis__inner">
          <div className="rec-gratis__head reveal">
            <div className="rec-gratis__head-left">
              <div className="rec-gratis__badge-wrap">
                <span className="rec-gratis__badge"><IconGift/> Completamente gratis</span>
              </div>
              <h2>Materiales <em>gratuitos</em></h2>
            </div>
          </div>

          {loadingGratis ? (
            <div className="rec-gratis__loading"><IconSpinner/><span>Cargando recursos gratuitos…</span></div>
          ) : gratisData.length === 0 ? (
            <div className="rec-gratis__empty"><p>Próximamente nuevos recursos gratuitos.</p></div>
          ) : (
            <div className="rec-gratis__grid">
              {gratisData.map((r,i) => {
                const colKey = COLOR_CAT[r.categoria]||'verde';
                const col    = colorMap[colKey]||colorMap.verde;
                return (
                  <article className="gratis-card reveal" key={r.id} style={{'--delay':`${i*0.08}s`}}>
                    <div className="gratis-card__thumb" style={{background:col.bg,position:'relative',overflow:'hidden',aspectRatio:'4/3'}}>
                      <div className="gratis-card__thumb-icon" style={{color:col.text}}>
                        {TIPO_ICONO_GRATIS[r.tipo]||<IconPdf/>}
                      </div>
                      {/* Badge rojo dto en gratuitos */}
                     {/*  <div className="mat-card__dto-badge">30% Dto.</div>*/}
                      <div className="gratis-card__thumb-badges">
                        <span className="gratis-badge gratis-badge--free"><IconUnlock/> GRATIS</span>
                        <span className="gratis-badge gratis-badge--tipo">{TIPO_LABEL_GRATIS[r.tipo]||r.tipo}</span>
                      </div>
                      <div className="gratis-card__descargas"><IconDownload/>{(r.total_descargas||0)+40}</div>
                    </div>
                    <div className="gratis-card__body">
                      {r.categoria && <span className="gratis-card__cat">{r.categoria.toUpperCase()}</span>}
                      <h3>{r.titulo}</h3>
                      {r.descripcion && <p>{r.descripcion}</p>}
                    </div>
                    <div className="gratis-card__footer">
                      <span className="gratis-card__precio">Gratis</span>
                      <button className="gratis-card__btn" onClick={()=>abrirModal(r)}>
                        {r.archivo_url ? <><IconDownload/> Descargar</> : <><IconLock/> Obtener</>}
                      </button>
                    </div>
                  </article>
                );
              })}
            </div>
          )}

          <div className="rec-gratis__cta reveal">
            <div className="rec-gratis__cta-inner">
              <div>
                <strong>¿Quieres tener acceso a nuevos recursos para usar en terapia?</strong>
                <p>Suscríbete y sé el primero en enterarte de nuestras novedades</p>
              </div>
              <Link to="/comunidad#boletin" className="rec-gratis__cta-btn">Suscribirme gratis <IconArrow/></Link>
            </div>
          </div>
        </div>
      </section>

      {/* ══ IMPRIMIBLES ══ */}
      <MatBloque id="imprimibles" label="PDFs descargables" titulo="Imprimibles" tituloEm=""
        
        bg="mat-bloque--oscuro" icon={<IconPdf/>} items={imprimibles} loading={loadingPaga}
        onComprar={abrirCompra} iconMap={iconMap} estaLogueado={estaLogueado}
        onLoginRequerido={() => navigate('/login?redirect=/recursos')}/>

      {/* ══ KITS / CUADERNILLOS ══ */}
      <MatBloque id="kits" label="Pack completo" titulo="Cuadernillo" tituloEm=""
       
        bg="mat-bloque--gris" icon={<IconKit/>} items={kits} loading={loadingPaga}
        onComprar={abrirCompra} iconMap={iconMap} estaLogueado={estaLogueado}
        onLoginRequerido={() => navigate('/login?redirect=/recursos')}/>

      {/* ══ JUEGOS ══ */}
     {/*  <MatBloque id="juegos" label="Juegos imprimibles" titulo="Juegos" tituloEm=""
        sub="Recursos gratuitos para aplicar en sesión desde hoy. Solo regístrate y recíbelos al instante."
        bg="mat-bloque--gris" icon={<IconGame/>} items={juegos} loading={loadingPaga}
        onComprar={abrirCompra} iconMap={iconMap} estaLogueado={estaLogueado}
        onLoginRequerido={() => navigate('/login?redirect=/recursos')}/>  */}

      {/* ══ FOOTER ══ */}
      <footer className="footer">
        <div className="footer__top">
          <div className="footer__brand">
            <p className="footer__brand-desc">Cursos especializados y materiales terapéuticos para profesionales y familias que trabajan el desarrollo del lenguaje.</p>
            <div className="footer__social">
              <a href="https://www.instagram.com/comunicar_terapias" className="footer__social-btn" aria-label="Instagram"><svg viewBox="0 0 24 24" fill="none" width="17" height="17"><rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg></a>
              <a href="https://www.facebook.com/comunicar.terapias" className="footer__social-btn" aria-label="Facebook"><svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></a>
              <a href="https://api.whatsapp.com/send/?phone=51940686868" className="footer__social-btn" aria-label="WhatsApp"><svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></a>
            </div>
          </div>
          <div className="footer__cols">
            <div className="footer__col">
              <h4>Cursos</h4>
              <Link to="/formaciones#gratuitos">Cursos gratuitos</Link>
              <Link to="/formaciones">Cursos grabados</Link>
              <Link to="/formaciones">Cursos en vivo</Link>
              <a href="https://centrocomunicar.com/virtual/login/index.php" target="_blank" rel="noopener noreferrer">Aula virtual ↗</a>
            </div>
            <div className="footer__col">
              <h4>Materiales</h4>
              <Link to="/recursos">Materiales gratuitos</Link>
              <Link to="/recursos">Imprimibles</Link>
              <Link to="/recursos">Cuadernillos</Link>
              <Link to="/recursos">Juegos terapéuticos</Link>
            </div>
            <div className="footer__col">
              <h4>Comunidad</h4>
              <Link to="/comunidad">Redes sociales</Link>
              <Link to="/comunidad">Boletín mensual</Link>
              <Link to="/comunidad">Programa de puntos</Link>
            </div>
          </div>
          <div className="footer__newsletter">
            <h4>Recibe novedades</h4>
            <p>Materiales gratuitos y nuevos recursos en tu correo.</p>
            <div className="footer__form">
              <input type="email" placeholder="tu@correo.com" className="footer__input"/>
              <button className="footer__submit"><IconArrow/></button>
            </div>
            <div className="footer__legal-links">
              <Link to="/atencion-cliente">Atención al cliente</Link>
              <Link to="/legal">Legal</Link>
              <Link to="/libro-reclamaciones">Libro de reclamaciones</Link>
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          <p>© 2026 Comunicar – Desarrollo y Lenguaje. Todos los derechos reservados.</p>
          <div className="footer__legal">
            <Link to="/legal">Privacidad</Link>
            <Link to="/legal">Términos y condiciones</Link>
            <Link to="/politica-devoluciones">Política de devoluciones</Link>
          </div>
        </div>
      </footer>

      {/* ══ MODAL DESCARGA GRATUITA ══ */}
      {modalRecurso && (
        <div className="rec-modal-overlay" onClick={()=>setModalRecurso(null)}>
          <div className="rec-modal" onClick={e=>e.stopPropagation()}>
            {descargaOk ? (
              <div className="rec-modal__exito">
                <div className="rec-modal__exito-icon">
                  <svg viewBox="0 0 24 24" fill="none" width="40" height="40"><circle cx="12" cy="12" r="10" fill="#d4f4e8"/><path d="M8 12l3 3 5-5" stroke="#4db88a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </div>
                <h3>¡Recurso en camino!</h3>
                <p>Hemos enviado <strong>{modalRecurso.titulo}</strong> a tu correo.</p>
                {descargaUrl && <a href={descargaUrl} target="_blank" rel="noopener noreferrer" className="rec-modal__btn-dl"><IconDownload/> Descargar ahora</a>}
                <button className="rec-modal__cerrar" onClick={()=>setModalRecurso(null)}>Cerrar</button>
              </div>
            ) : (
              <>
                <div className="rec-modal__head">
                  <div className="rec-modal__recurso-info">
                    <span className="rec-modal__tipo-badge">{TIPO_LABEL_GRATIS[modalRecurso.tipo]||modalRecurso.tipo} · Gratis</span>
                    <h3>{modalRecurso.titulo}</h3>
                  </div>
                  <button className="rec-modal__close" onClick={()=>setModalRecurso(null)}>
                    <svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>
                  </button>
                </div>
                <form className="rec-modal__form" onSubmit={handleDescargar}>
                  {formError && <div className="rec-modal__error">{formError}</div>}
                  <div className="rec-modal__field">
                    <label>Tu nombre</label>
                    <input type="text" placeholder="Ej: Ana García" value={formGratis.nombre} onChange={e=>setFormGratis(f=>({...f,nombre:e.target.value}))} required/>
                  </div>
                  <div className="rec-modal__field">
                    <label>Correo electrónico</label>
                    <input type="email" placeholder="tu@correo.com" value={formGratis.email} onChange={e=>setFormGratis(f=>({...f,email:e.target.value}))} required/>
                  </div>
                  <button type="submit" className="rec-modal__submit" disabled={enviando}>
                    {enviando ? <><IconSpinner/> Procesando…</> : <><IconDownload/> Descargar gratis</>}
                  </button>
                  <p className="rec-modal__legal"><IconCheck/> Sin spam · Puedes darte de baja cuando quieras</p>
                </form>
              </>
            )}
          </div>
        </div>
      )}

      {/* ══ MODAL COMPRA ══ */}
      {modalCompra && (
        <div className="rec-modal-overlay" onClick={()=>setModalCompra(null)}>
          <div className="rec-modal rec-modal--compra" onClick={e=>e.stopPropagation()}>
            <div className="rec-modal__head">
              <div className="rec-modal__recurso-info">
                <span className="rec-modal__tipo-badge rec-modal__tipo-badge--paga">
                  {modalCompra.tipo==='kit'?'Kit':modalCompra.tipo==='juego'?'Juego':'Recurso'} · S/. {parseFloat(modalCompra.precio||0).toFixed(2)}
                </span>
                <h3>{modalCompra.titulo}</h3>
              </div>
              <button className="rec-modal__close" onClick={()=>setModalCompra(null)}>
                <svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>
              </button>
            </div>
            {compraStep === 'info' && (
              <div className="rec-compra-info">
                {(modalCompra.imagenes||[]).length > 0 && <MockupGaleria imagenes={modalCompra.imagenes}/>}
                {modalCompra.descripcion && <p className="rec-compra-desc">{modalCompra.descripcion}</p>}
                {modalCompra.descripcion_larga && (
                  <p className="rec-compra-desc" style={{marginTop:'.5rem',color:'#5a6a63',fontSize:'.88rem',lineHeight:1.7}}>
                    {modalCompra.descripcion_larga}
                  </p>
                )}
                <div className="rec-compra-precio-box">
                  <div>
                    <span className="rec-compra-precio">S/. {parseFloat(modalCompra.precio||0).toFixed(2)}</span>
                    {modalCompra.precio_antes && <span className="rec-compra-precio-antes">S/. {parseFloat(modalCompra.precio_antes).toFixed(2)}</span>}
                  </div>
                  {modalCompra.precio_antes && <span className="rec-compra-ahorro">Ahorras S/. {(parseFloat(modalCompra.precio_antes)-parseFloat(modalCompra.precio||0)).toFixed(2)}</span>}
                </div>
                <div className="rec-compra-features">
                  {modalCompra.formato  && <div><IconCheck/>{modalCompra.formato}</div>}
                  {modalCompra.nivel    && <div><IconCheck/>Nivel {modalCompra.nivel}</div>}
                  {modalCompra.paginas  && <div><IconCheck/>{modalCompra.paginas} páginas</div>}
                  <div><IconCheck/>Descarga inmediata tras validar pago</div>
                </div>
                <div className="rec-compra-flujo">
                  <p className="rec-compra-flujo__label">📋 ¿Cómo funciona?</p>
                  <div className="rec-compra-flujo__steps">
                    <div><span>1</span>Completa tus datos</div>
                    <div><span>2</span>Recibe instrucciones de pago por WhatsApp</div>
                    <div><span>3</span>Realiza el pago y adjunta tu voucher</div>
                    <div><span>4</span>Acceso activado en tu cuenta en minutos</div>
                  </div>
                </div>
                {!metodoPagoModal ? (
                  <div className="rec-metodo-selector">
                    <p className="rec-metodo-selector__label">¿Cómo deseas pagar?</p>
                    {!estaLogueado ? (
                      <div style={{background:'#fff8ed',border:'1px solid #fcd34d',borderRadius:12,padding:'1rem 1.1rem',fontSize:'.82rem',color:'#92400e'}}>
                        <div style={{display:'flex',alignItems:'center',gap:'.5rem',marginBottom:'.75rem'}}><span style={{fontSize:'1.1rem'}}>🔐</span><strong>Necesitas una cuenta para comprar</strong></div>
                        <p style={{margin:'0 0 1rem',fontWeight:400,lineHeight:1.6,color:'#78350f'}}>Inicia sesión o crea una cuenta gratuita para descargar tus recursos.</p>
                        <div style={{display:'flex',gap:'.6rem'}}>
                          <button onClick={()=>{ sessionStorage.setItem('compra_pendiente',JSON.stringify({recurso_id:modalCompra.id,titulo:modalCompra.titulo,precio:modalCompra.precio})); window.location.href='/login?redirect=/recursos'; }} style={{flex:1,background:'#111614',color:'#82D8B3',border:'none',borderRadius:100,padding:'.75rem 1rem',fontFamily:"'DM Sans',sans-serif",fontWeight:700,fontSize:'.82rem',cursor:'pointer'}}>Iniciar sesión</button>
                          <button onClick={()=>{ sessionStorage.setItem('compra_pendiente',JSON.stringify({recurso_id:modalCompra.id,titulo:modalCompra.titulo,precio:modalCompra.precio})); window.location.href='/registro?redirect=/recursos'; }} style={{flex:1,background:'#edfaf4',color:'#0f3525',border:'1.5px solid rgba(130,216,179,.4)',borderRadius:100,padding:'.75rem 1rem',fontFamily:"'DM Sans',sans-serif",fontWeight:700,fontSize:'.82rem',cursor:'pointer'}}>Crear cuenta</button>
                        </div>
                      </div>
                    ) : (
                      <div className="rec-metodo-btns">
                        <button className="rec-metodo-btn rec-metodo-btn--tarjeta" onClick={()=>setMetodoPagoModal('tarjeta')}>
                          <span>💳</span><div><strong>Pagar con tarjeta</strong><span>Visa, Mastercard — acceso inmediato</span></div>
                        </button>
                        <button className="rec-metodo-btn rec-metodo-btn--voucher" onClick={()=>{ setMetodoPagoModal('voucher'); setCompraStep('form'); }}>
                          <span>📱</span><div><strong>Yape / Transferencia</strong><span>Subir voucher — validación en 24h</span></div>
                        </button>
                      </div>
                    )}
                  </div>
                ) : metodoPagoModal === 'tarjeta' ? (
                  <div className="rec-izipay-wrap">
                    <button className="rec-metodo-cambiar" onClick={()=>{ setMetodoPagoModal(null); setIziForm(null); setIziError(''); }}>← Cambiar método</button>
                    <IzipayForm recursoId={modalCompra?.id} monto={montoFinal} email={usuario?.email||''} nombre={usuario?.nombre||'Cliente'}/>
                  </div>
                ) : null}
              </div>
            )}
            {compraStep === 'form' && (
              <form className="rec-modal__form" onSubmit={handleComprar}>
                {comprError && <div className="rec-modal__error">{comprError}</div>}
                <div className="rec-modal__field">
                  <label>Nombre completo</label>
                  <input type="text" placeholder="Ej: Ana García" value={formCompra.nombre} onChange={e=>setFormCompra(f=>({...f,nombre:e.target.value}))} required/>
                </div>
                <div className="rec-modal__field">
                  <label>Correo electrónico</label>
                  <input type="email" placeholder="tu@correo.com" value={formCompra.email} onChange={e=>setFormCompra(f=>({...f,email:e.target.value}))} required/>
                </div>
                <div className="rec-modal__field">
                  <label>WhatsApp <span style={{fontWeight:400,color:'#5a6a63'}}>— para enviarte las instrucciones</span></label>
                  <input type="tel" placeholder="9XX XXX XXX" value={formCompra.telefono} onChange={e=>setFormCompra(f=>({...f,telefono:e.target.value}))}/>
                </div>
                {estaLogueado && puntosDisponibles >= 500 && (
                  <div className="rec-puntos-canje">
                    <div className="rec-puntos-canje__head">
                      <div className="rec-puntos-canje__info">
                        <IconStar/>
                        <div><strong>Tienes {puntosDisponibles.toLocaleString()} puntos</strong><span>= S/. {(puntosDisponibles/100).toFixed(2)} de descuento máximo</span></div>
                      </div>
                      <label className="rec-puntos-toggle">
                        <input type="checkbox" checked={usarPuntos} onChange={e=>{ setUsarPuntos(e.target.checked); if(e.target.checked){setPuntosAplicar(puntosMaxUsar);}else{setPuntosAplicar(0);} }}/>
                        <span className="rec-puntos-toggle__slider"/>
                      </label>
                    </div>
                    {usarPuntos && (
                      <div className="rec-puntos-canje__detalle">
                        <div className="rec-puntos-canje__slider-wrap">
                          <label>Puntos a usar: <strong>{puntosAplicar.toLocaleString()}</strong><span> = S/. {(puntosAplicar/100).toFixed(2)} de descuento</span></label>
                          <input type="range" min={500} max={puntosMaxUsar} step={100} value={puntosAplicar} onChange={e=>setPuntosAplicar(parseInt(e.target.value))} className="rec-puntos-range"/>
                          <div className="rec-puntos-canje__minmax"><span>500 pts (mín.)</span><span>{puntosMaxUsar.toLocaleString()} pts (máx. 30%)</span></div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className="rec-compra-resumen">
                  <div className="rec-compra-resumen__left">
                    <span>{modalCompra.titulo}</span>
                    {usarPuntos && descuentoPuntos > 0 && <span className="rec-compra-resumen__desc">− S/. {descuentoPuntos.toFixed(2)} con puntos</span>}
                  </div>
                  <div className="rec-compra-resumen__right">
                    {usarPuntos && descuentoPuntos > 0 && <s className="rec-compra-precio-orig">S/. {parseFloat(modalCompra.precio||0).toFixed(2)}</s>}
                    <strong className={usarPuntos&&descuentoPuntos>0?'rec-compra-precio-final':''}>S/. {montoFinal.toFixed(2)}</strong>
                  </div>
                </div>
                <button type="submit" className="rec-modal__submit rec-modal__submit--wa" disabled={comprando}>
                  {comprando ? <><IconSpinner/> Procesando…</> : <><IconWhatsapp/> Continuar por WhatsApp</>}
                </button>
                <button type="button" className="rec-modal__back" onClick={()=>setCompraStep('info')}>← Volver</button>
                <p className="rec-modal__legal"><IconShield/> Tus datos están seguros · No compartimos tu información</p>
              </form>
            )}
            {compraStep === 'ok' && pedidoData && (
              <div className="rec-modal__exito">
                <div className="rec-modal__exito-icon" style={{background:'#f0fdf4',color:'#25d166',width:64,height:64,borderRadius:18,display:'flex',alignItems:'center',justifyContent:'center'}}>
                  <IconWhatsapp/>
                </div>
                <h3>¡Pedido registrado!</h3>
                <p>Tu pedido <strong>{pedidoData.codigo}</strong> ha sido creado.</p>
                <p style={{fontSize:'.85rem',color:'#5a6a63',textAlign:'center'}}>Haz clic para abrir WhatsApp con las instrucciones de pago ya preparadas.</p>
                <div className="rec-modal__pedido-info">
                  <div><span>Pedido</span><strong>{pedidoData.codigo}</strong></div>
                  <div><span>Total</span><strong>S/. {parseFloat(pedidoData.monto||0).toFixed(2)}</strong></div>
                </div>
                <button className="rec-compra-btn-wa" onClick={abrirWhatsApp}><IconWhatsapp/> Abrir WhatsApp para pagar</button>
                <button className="rec-modal__cerrar" onClick={()=>setModalCompra(null)}>Cerrar</button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Widget redes sociales flotante */}
      <div style={{position:'fixed',right:0,top:'50%',transform:'translateY(-50%)',zIndex:100,display:'flex',flexDirection:'column',gap:2}}>
        {[
          {href:'https://www.facebook.com/comunicar.terapias',bg:'#1877f2',icon:<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>},
          {href:'https://www.instagram.com/comunicar_terapias',bg:'#e1306c',icon:<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg>},
          {href:'https://api.whatsapp.com/send/?phone=51940686868',bg:'#25d366',icon:<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>},
          {href:'https://www.youtube.com/@CentroComunicar',bg:'#ff0000',icon:<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 00-1.95 1.96A29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"/></svg>},
        ].map(({href,bg,icon}) => (
          <a key={href} href={href} target="_blank" rel="noopener noreferrer"
            style={{width:40,height:40,background:bg,display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',transition:'opacity .2s'}}
            onMouseEnter={e=>e.currentTarget.style.opacity='.8'}
            onMouseLeave={e=>e.currentTarget.style.opacity='1'}>
            {icon}
          </a>
        ))}
      </div>

    </div>
  );
}